import { z } from 'zod';

export interface ISingUpForm {
	email?: string;
	phone?: string;
	name: string;
	accountName?: string;
	password?: string;
	timezone?: string;
	pricingId?: string;
}

export const SingUpSchema: z.ZodType<ISingUpForm> = z.object({
	email: z.string().email('Email is not valid').optional(),
	phone: z.string().optional(),
	name: z.string().nonempty('Name is required'),
	accountName: z.string().optional(),
	password: z
		.string()
		.min(8, 'Password must be at least 8 characters')
		.refine(
			(value: string) => /^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(value),
			'Password must contain at least 1 letter and 1 number',
		)
		.optional(),
	timezone: z
		.string()
		.default(Intl.DateTimeFormat().resolvedOptions().timeZone),
	pricingId: z.string().optional(),
}).refine(
	(data) => {
		// Either email or phone must be provided
		return data.email || data.phone;
	},
	{
		message: 'Either email or phone number is required',
		path: ['email'],
	}
);
